export default __webpack_public_path__ + "static/media/exportIcon.e1c26fd5.svg";